//handling the http and https

function hasTouchSupport() {//return true if the screen is touchable
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }
  
function isMobileOrTablet() {//testing the touching abilaty and the screen size
  if(hasTouchSupport()){
    const minWidth = 800; // Minimum width for desktop devices
    return window.innerWidth < minWidth;
  }
  else{
    return false;
  }
  }
  
  
  const getChromeVersion = () => {//if the browser is chrome (which is the browser for most android devices) return the version
    const userAgent = navigator.userAgent;
    const match = userAgent.match(/Chrome\/(\d+)/);
    if (match) {
      let chromeVersion = parseInt(match[1], 10);
      return chromeVersion;
    }
    else{
      return null;
    }
  };
  
  
export const choiseHttpOrHttps = ()=>{
   if(isMobileOrTablet()){
      let chromeVersion = getChromeVersion();
      if(chromeVersion && chromeVersion < 100 ){
        return "http://";
      }
    }
  
    return "https://";
   }